import React from 'react';

const NotFound = () => {
  return (
    <div>No Route Found</div>
  )
}

export default NotFound;